import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import { baseUrl } from "../../../../../../shared/config";
import Carousel from "../../../../../blocks/Carousel";
import Card from "../../../../../blocks/Carousel/Card";
import CardImage from "../../../../../blocks/Carousel/Card/Image";
import { Dialog, useMediaQuery, useTheme, IconButton } from "@mui/material";
import LabelledSwitch from "../../../../../components/LabelledSwitch";
import PreviewMarker from "../../partials/PreviewMarker";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useParams } from "react-router-dom";
import { useRegisterView } from "../../../../../../features/quadrants/api/registerView";
import { useResourcesViewedStatus } from "../../../../../../features/quadrants/api/getQuadrantViewedStatus";
import { useWaterMark } from "../../../../../../features/quadrants/hooks/useWaterMark";
import { cn } from "../../../../../../shared/utils/cn";
import { Fullscreen } from "@mui/icons-material";

function ImageContent({
  contentId,
  sx = {},
  value,
  isEditing,
  setMandatory,
  enrollment,
  chapters,
  canBeMandatory = false,
  isConfidential,
}) {
  const { currentChapter } = useParams();

  const waterMarkCN = useWaterMark();
  const [imageOnView, setImageOnView] = useState(null);
  const [images, setImages] = useState([]);
  const resourcesViewsQuery = useResourcesViewedStatus({
    chapterId: currentChapter,
    enrollmentId: enrollment?.MATRICULAID,
    quadrantId: contentId,
    resourcesIds: images?.map((image) => image.resourceId),
  });
  const registerViewMutation = useRegisterView();

  const handleCloseView = () => setImageOnView(null);

  const handleOpenImage = (image) => {
    setImageOnView(image.url);
    registerViewMutation.mutate({
      chapterId: currentChapter,
      enrollmentId: enrollment?.MATRICULAID,
      quadrantId: contentId,
      resourceId: image.resourceId,
    });
  };

  const urlPattern =
    // eslint-disable-next-line no-useless-escape
    /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

  useEffect(() => {
    try {
      setImages(
        value
          ?.filter((attachment) => attachment?.condition !== "removed")
          ?.map((attachment) => ({
            ...attachment,
            url: attachment?.link
              ? urlPattern.test(attachment?.link)
                ? attachment?.link
                : `${baseUrl}${attachment?.link}`
              : "",
          }))
      );
    } catch (error) {
      console.log(error, value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  const isCarousel = images?.length > 1;

  const theme = useTheme();
  const breakString = theme.breakpoints.up("md");
  const isDisplayMedium = useMediaQuery(breakString);

  if (!images) {
    return <></>;
  }
  return (
    <>
      {isCarousel ? (
        <Carousel>
          {images?.map((image, index) => (
            <Card key={`image-${image.url}`}>
              <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
                <Box
                  sx={{ width: "100%", height: "100%", cursor: "pointer" }}
                  onClick={() => handleOpenImage(image)}
                  className={isConfidential && waterMarkCN.Watermark}
                >
                  <CardImage isImage url={image.url} />
                </Box>
                {!isEditing && image.mandatory === "S" && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: "0",
                    }}
                  >
                    <PreviewMarker
                      onClick={() => handleOpenImage(image)}
                      viewed={resourcesViewsQuery[index].data?.viewed}
                      TooltipValue={
                        index === 0 ? "Abra as imagens em tela cheia" : null
                      }
                    />
                  </Box>
                )}
                {isEditing && canBeMandatory && (
                  <Box sx={{ position: "absolute", bottom: "0" }}>
                    <LabelledSwitch
                      label={isDisplayMedium ? "Obrigatório?" : null}
                      color="#6186F8"
                      labelPlacement="start"
                      fontWeight="700"
                      textTransform="uppercase"
                      fontSize="small"
                      sx={{
                        marginRight: "0",
                        marginLeft: "0.5rem",
                      }}
                      value={value[index].mandatory === "S"}
                      onChange={(event) =>
                        setMandatory(index, event.target.checked ? "S" : "N")
                      }
                    />
                  </Box>
                )}
              </Box>
            </Card>
          ))}
        </Carousel>
      ) : (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "hidden",
          }}
          className={isConfidential && waterMarkCN.Watermark}
        >
          {/* <ImageWithBackdrop url={images[0]?.url} /> */}
          <Box
            component="img"
            sx={{
              height: "100%",
              maxWidth: "100%",
              display: "block",
              margin: "auto",
              objectFit: "contain",
              maxHeight: "100%",
            }}
            alt=""
            src={images[0]?.url}
            onClick={() => handleOpenImage(images[0])}
          />
          {!isEditing && images[0]?.mandatory === "S" && (
            <Box
              sx={{
                position: "absolute",
                top: "0",
              }}
            >
              <PreviewMarker
                viewed={resourcesViewsQuery[0].data?.viewed}
                TooltipValue={"Abra em tela cheia"}
              />
            </Box>
          )}
          <IconButton
            sx={{ position: "absolute", top: 3, right: 3 }}
            onClick={() => handleOpenImage(images[0])}
          >
            <Fullscreen />
          </IconButton>
        </Box>
      )}

      <Dialog open={!!imageOnView} onClose={handleCloseView}>
        <div
          className={cn(
            isConfidential && waterMarkCN.Watermark,
            isConfidential && "overflow-hidden"
          )}
        >
          <Box
            component="img"
            sx={{ ...sx, width: "100%", height: "100%", objectFit: "contain" }}
            alt=""
            src={imageOnView}
          />
        </div>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  enrollment: state.course?.enrollment,
  chapters: state.course?.chapters,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ImageContent);
